import styled from 'styled-components';

const ErrorMsgStyle = styled.div`
	.errorMsg {
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		background: var(--errorColor);
		color: var(--color1);
		animation: TranslateFromTop var(--trTime) ease-out forwards;
		min-height: var(--sp2-5x);
		padding: var(--sp1x) var(--sp2x);
		display: flex;
		align-items: center;

		.closeError {
			position: absolute;
			right: var(--sp2x);
			top: var(--sp1x);
			cursor: pointer;
		}
	}

	.errMsg {
		position: absolute;
		top: 100%;
		margin-top: var(--sp0-75x);
		color: var(--errorColor) !important;
	}
`;

export default ErrorMsgStyle;
